import styled from "styled-components";
import css from "@styled-system/css";

export const Cards = styled("div")(
  css({
    display: ["block", "flex"],
    justifyContent: "space-between",
    alignItems: "stretch",
    dl: {
      my: 24,
      display: "flex",
      flexDirection: "column",
    },
    dt: {
      background: "#fff",
      borderRadius: "30px 30px 0px 0px",
      p: 20,
      mb: "4px",
      h4: {
        fontWeight: "bold",
        fontSize: [3, 4],
        lineHeight: 1,
        m: 0,
        ":first-child:last-child": {
          fontSize: [3, "40px"],
        },
      },
    },
    dd: {
      borderRadius: "0px 0px 30px 30px",
      background: "#fff",
      padding: 20,
      m: 0,
      flexGrow: 1,

      fontSize: [1, 2],

      p: {
        m: 0,
      },
    },
  })
);

export const Title = styled(
  css({
    fontSize: [2, 3],
    fontWeight: "bold",
  })
);

export const InfoCard = styled("div")({
  padding: 30,
  background: "#fff",
  borderRadius: "30px",
});
